export default "__VITE_ASSET__BQOIrLaI__"